import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const SanctionPurchaseListApi = (data) =>
    API.post(
        `${URL.CLUB_SANCTION_ALL_LIST}?_limit=${data?.params?._limit || ''}&_page=${data?.params?._page || ''}&_sort=${data?.params?._sort || ''}&_order=${data?.params?._order || ''}`,
        data.bodyData
    )

export const SanctionGrandTotalApi = (data) =>
    API.post(`${URL.SANCTION_LIST_GRAND_TOTAL_URL}`, data)

export const SanctionShowDateUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderId = data.master_sanction_order_id
    const payload = { show_date: data.show_date }
    return API.patch(`${URL.SANCTION_SHOW_DATE_UPDATE}/${masterSanctionOrderId}`, payload)
}

export const SanctionShowNameUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderId = data.master_sanction_order_id
    const payload = { show_name: data.show_name }
    return API.patch(`${URL.SANCTION_SHOW_NAME_UPDATE}/${masterSanctionOrderId}`, payload)
}

export const SanctionHostNameUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderId = data.master_sanction_order_id
    const payload = { host_name: data.host_name }
    return API.patch(`${URL.SANCTION_HOST_NAME_UPDATE}/${masterSanctionOrderId}`, payload)
}

export const SanctionSecretaryNameUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderDetailsId = data.master_sanction_order_details_id
    const payload = { secretary_name: data.secretary_name }
    return API.patch(`${URL.SANCTION_SECRETARY_NAME_UPDATE}/${masterSanctionOrderDetailsId}`, payload)
}

export const SanctionSecretaryEmailUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderId = data.master_sanction_order_id
    const payload = { user_id: data.user_id }
    return API.patch(`${URL.SANCTION_SECRETARY_EMAIL_UPDATE}/${masterSanctionOrderId}`, payload)
}

export const SanctionTypeUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderDetailsId = data.master_sanction_order_details_id
    const payload = { sanction_type: data.sanction_type }
    return API.patch(`${URL.SANCTION_TYPE_UPDATE}/${masterSanctionOrderDetailsId}`, payload)
}

export const SanctionArbaNumberUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderDetailsId = data.master_sanction_order_details_id
    const payload = { arba_number: data.arba_number, club_id: data.club_id }
    return API.patch(`${URL.SANCTION_ARBA_NUMBER_UPDATE}/${masterSanctionOrderDetailsId}`, payload)
}

export const SanctionSecretaryAddressUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderDetailsId = data.master_sanction_order_details_id
    const payload = {
        address: data.address,
        country_id: data.country_id,
        state_id: data.state_id,
        city: data.city,
        zipcode: data.zipcode,
        club_id: data.club_id
    }
    return API.patch(`${URL.SANCTION_SECRETARY_ADDRESS_UPDATE}/${masterSanctionOrderDetailsId}`, payload)
}

export const SanctionShowAddressUpdateApi = (data) => {
    // eslint-disable-next-line camelcase
    const masterSanctionOrderId = data.master_sanction_order_id
    const payload = {
        show_address: data.show_address,
        country_id: data.country_id,
        state_id: data.state_id,
        city: data.city,
        zipcode: data.zipcode,
        club_id: data.club_id
    }
    return API.patch(`${URL.SANCTION_SHOW_ADDRESS_UPDATE}/${masterSanctionOrderId}`, payload)
}

export const SanctionArchiveUpdateApi = (data) => {
    return API.post(`${URL.UPDATE_SANCTION_LIST_ARCHIVE_STATUS}`, data)
}